export default __webpack_public_path__ + "static/media/DesignService360DevPro.ec112775.png";